var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"secondary grey--text text--uppercase",attrs:{"absolute":""}},[_c('v-spacer'),_c('div',{staticClass:"overline"},[_vm._v(" v1.0 © Logitricks "+_vm._s(new Date().getFullYear())+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }